import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import Vas from '../../../Vas';
import '../../../css/CustomerDocumentUpload.css';
import { ExtendedButton,TextField,Icon, MessageBox } from 'component-lib';
import { DocumentsModel, RequestAjaxClass} from 'models-lib';

class CustomerDocumentUpload extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.files='';
        this.state.fileName='';
        this.CustomerId = props.match.params.CustomerId;
        this.DocumentsModel = new DocumentsModel([this]);
        this.PostRequest = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    }

    componentDidMount(){
        this.PostRequest.setApiUrl(Vas.ApiUrl);
        this.PostRequest.setApiKey(Vas.ApiKey);
        this.PostRequest.setAuth(true);
        this.PostRequest.setType("POST");
        this.PostRequest.setErrorHandler((data)=>{
          $("#LoadingIconPopUp").removeClass().addClass('hide');
        });

        this.DocumentsModel.SetRequest(this.PostRequest);
    }

    FileUpload() {
        $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
        this.DocumentsModel.UploadDocument(this.CustomerId,this.state.files);
    }

    Update(observer)
    {
        this.setState({},()=>{
          if(observer === "UploadDocument"){
            $("#LoadingIcon").removeClass().addClass('hide');
            if(this.DocumentsModel.UploadSuccess === true){
              $("#LoadingIconPopUp").removeClass().addClass('hide');
              Vas.GetView("CustomerDocumentUploadSuccess", {CustomerId:this.CustomerId}, true);
            }else{
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Message={Vas.Resources.ErrorMessages["UnexpectedError"]} 
                Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));
            }
          }
        });
    }

    Close(){
      
      if(localStorage.getItem('DocumentSchoolUpload') === 'false'){
        localStorage.removeItem('DocumentSchoolUpload');
        Vas.GetView("CustomerCardData",{Id:this.CustomerId},true);
      }else{
        localStorage.removeItem('DocumentSchoolUpload');
        Vas.GetView("DocumentUpload",null,true);
      }
    }

    storeFile(event){
        let type = event.target.files[0].type;
        if ((type.slice(0,5) === "image") || (type === "application/pdf") || (type === "application/msword") || 
          (type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")){
            this.refs.FileText.setState({ Value:event.target.files[0].name });
            this.setState({ files:event.target.files, fileName:event.target.files[0].name },()=>{ 
                if (this.state.fileName.length>0){
                    this.refs.btoDone.setState({ usable:true });
                } else {
                    this.refs.btoDone.setState({ usable:false });
                }
            }); 
        }
    }

    render()
    {

      let editButton = (
        <ExtendedButton 
          Id={"btoChoose"} 
          Usable={true} 
          Text={<Icon
          Name={"Upload"} 
          Size={18} 
          Color={"black"} 
          PaddingLeft={'0px'} 
          PaddingTop={'0px'}
          Tooltip={Vas.Resources.Tooltips["ChooseDocument"]} />}
          Width={30} 
          Height={30} 
          Type={"Round"} 
          OnClick={()=>{$("#fileUpload").trigger('click');}} />);

      if(Vas.isIE) {
        editButton = (
          <ExtendedButton 
            Id={"btoChoose"} 
            Usable={true} 
            Text={<Icon
            Name={"Upload"} 
            Size={18} 
            Color={"black"} 
            PaddingLeft={'0px'} 
            PaddingTop={'0px'}
            Tooltip={Vas.Resources.Tooltips["ChooseDocument"]} />}
            Width={30} 
            Height={30} 
            Type={"Round"} />);
      }

        return (
        <div className={"form documentUploadForm"}>
          <table>
            <thead>
              <tr>
                <th className={"headerChange"} colSpan={2}>
                    {Vas.Resources.Labels["UploadDocument"]}
                    <br/>
                    <br/>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <table >
                    <tbody>
                      <tr>
                        <td>
                          <input 
                            id="fileUpload" 
                            type="file" 
                            className="inputfile" 
                            onChange={(event)=>{this.storeFile(event);}} 
                            accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, image/*" />
                          <label htmlFor="fileUpload">
                            <div style={{ marginTop: '30px' }}>
                              { editButton }
                            </div>
                          </label>
                        </td>
                        <td>
                          <TextField
                            AppURL={Vas.ApplicationUrl} 
                            Width={250} 
                            ref={"FileText"} 
                            Id="FileText" 
                            Value={this.state.fileName} 
                            Editable={false}  
                            Label={"Datei"} />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}><br />{Vas.Resources.Labels["ValidDocumentFormat"]}</td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <table>
                            <tbody>
                              <tr>
                                <td>
                                  <br /><ExtendedButton 
                                    Usable={false} 
                                    ref={"btoDone"} 
                                    Text={Vas.Resources.Labels["Upload"]} 
                                    Float={'left'}  
                                    OnClick={()=>{ this.FileUpload();}} 
                                    Width={100}
                                    />
                                </td>
                                <td>   
                                  <br /><ExtendedButton 
                                    Usable={true} 
                                    Text={Vas.Resources.Labels["Cancel"]} 
                                    Float={'left'} 
                                    OnClick={()=>{ this.Close();}} 
                                    Width={100}
                                    />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        );
    }
}
export default CustomerDocumentUpload;
